export default __webpack_public_path__ + "static/media/icon_after.37746423.svg";